import { useMutation } from '@tanstack/react-query';
import { logoutAdmin, logoutAffiliate, logoutUser } from '../Services/Auth';
import useUserStore from '../Stores/UserStore';
import { useNavigate } from 'react-router-dom';

export function useLogout() {
  const clearUser = useUserStore((state) => state.clearUser);
  let navigate = useNavigate();

  return useMutation({
    mutationFn: async (role) =>
      role === 'admin' ? logoutAdmin() : role === 'affiliate' ? logoutAffiliate() : logoutUser(),
    onSuccess: (_, role) => {
      // clear user on logout
      clearUser();
      useUserStore.persist.clearStorage();
      // Clear token from BOTH localStorage and cookie
      localStorage.removeItem('token');
      document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      // Navigate based on the role
      navigate(role === 'admin' ? '/admin/login' : role === 'affiliate' ? '/affiliate/login' : '/login');
    },
    onError: (error) => {
      // Handle errors here
      console.error('Error Logging out', error);
      if (error.message === 'Please Login First.') {
        clearUser();
        useUserStore.persist.clearStorage();
      }
    },
  });
}
